import { DatabaseEnum } from "@Shape-Digital/kudzu-data/lib/types/common";
import { Appointment } from "../AppointmentCardsContainer/types";

interface CheckIsCanBeRescheduledParams {
  appointment: Appointment | null;
  role?: DatabaseEnum["center_user_role"];
}

const checkIsCanBeRescheduled = ({
  appointment,
  role,
}: CheckIsCanBeRescheduledParams): boolean => {
  return !!(
    appointment &&
    role &&
    ["technologist", "super_admin", "regional_admin", "receptionist"].includes(
      role,
    ) &&
    ["confirmed", "intake_complete", "checked_in"].includes(appointment.status)
  );
};

export default checkIsCanBeRescheduled;
